import { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { Dialog } from "primereact/dialog";
import "./formStyle.css";
import { useDispatch, useSelector } from "react-redux";
import {  } from "../../reducers/customerSlice";
import { Text } from "../Text";
import Users from "./Users";
import Subscription from "./Subscription";
import Company from "./Company";

export const AddCustomer = ({ onHide, displayBasic, toast }) => {
  const { cform,header } = useSelector(
    (state) => state.customer
  );

  const portal=()=>{
      switch(cform){
        case "company":
          return <Company onHide={onHide}/> ;
        case "user":
          return <Users onHide={onHide}/>;
        case "subscription":
          return <Subscription onHide={onHide}/>;
        }
    }
  return (
    <Dialog
      header={ <Text type={'heading'}><span style={{textDecorationLine:"underline", textDecorationStyle:"dashed"}}>{`${header}`}</span></Text>}
      visible={displayBasic}
      className="dialog-custom"
      onHide={() => onHide()}>
       <div className="flex flex-row w-12 mb-2">
        </div>
      <div className={`card`}>
        {portal()}
      </div>
    </Dialog>
  );
};
